// Set to true to restore the trading page and its UI entry points.
export const TRADING_ENABLED = false
